import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { LouiseOffer } from '../../../../../../types/Quotes';
import { mq } from '../../../../../common/src/utils/styledComponentsUtils';
import { getGuaranteeNameForKey } from '../../../services/productFactoryService';
import LabelValue from '../../offers/LabelValue';
import OfferOptionButton from '../../offers/offer-options/OfferOptionButton';

interface Props {
  offer: LouiseOffer;
  isMobile?: boolean;
  isStatic?: boolean;
}

const SingleSelectedOfferOptions: React.FC<React.PropsWithChildren<Props>> = ({
  offer,
  isMobile,
  isStatic,
}) => {
  const { t } = useTranslation();

  return (
    <LabelValue label={isMobile ? '' : t('Chosen options')}>
      <OptionList>
        {offer.possible_guarantees.map((guarantee) => (
          <OfferOptionButton
            key={`OfferOptionButton_${guarantee}`}
            type={guarantee}
            active={offer.selected_guarantees.includes(guarantee)}
            disabled={isStatic}
            price={
              offer.guarantees?.find(({ name }) => name === guarantee)
                ?.total_premium
            }
          >
            {getGuaranteeNameForKey(guarantee, offer.guarantee_content)}
          </OfferOptionButton>
        ))}
      </OptionList>
    </LabelValue>
  );
};

const OptionList = styled.div`
  display: flex;
  flex-wrap: wrap;

  /* Flex gap fix for safari */
  margin: -0.8rem 0 0 -0.8rem;

  > * {
    margin: 0.8rem 0 0 0.8rem;
  }

  ${mq.laptop} {
    padding-top: 1.6rem;
  }
`;

export default SingleSelectedOfferOptions;
